 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import TEXTHALFTITLE from '@/components/Text/HalfTitle'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTFRONTOTHER01 from '@/components/Text/FrontOther01'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTFOREWORD from '@/components/Text/Foreword'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTPART01 from '@/components/Text/Part01'
 import TEXTCHAPTER01 from '@/components/Text/Chapter01'
 import TEXTCHAPTER02 from '@/components/Text/Chapter02'
 import TEXTCHAPTER03 from '@/components/Text/Chapter03'
 import TEXTPART02 from '@/components/Text/Part02'
 import TEXTCHAPTER04 from '@/components/Text/Chapter04'
 import TEXTCHAPTER05 from '@/components/Text/Chapter05'
 import TEXTCHAPTER06 from '@/components/Text/Chapter06'
 import TEXTCONCLUSION from '@/components/Text/Conclusion'
 import TEXTAPPENDIX from '@/components/Text/Appendix'
 import TEXTGLOSSARY from '@/components/Text/Glossary'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTABOUTAUTHOR from '@/components/Text/AboutAuthor'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Cover",
 			"name" : "Text/Cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/HalfTitle",
 			"name" : "Text/HalfTitle",
 			"component" : TEXTHALFTITLE
 		},
 		{
 			"path" : "/Text/TitlePage",
 			"name" : "Text/TitlePage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/Copyright",
 			"name" : "Text/Copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/FrontOther01",
 			"name" : "Text/FrontOther01",
 			"component" : TEXTFRONTOTHER01
 		},
 		{
 			"path" : "/Text/Dedication",
 			"name" : "Text/Dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/Foreword",
 			"name" : "Text/Foreword",
 			"component" : TEXTFOREWORD
 		},
 		{
 			"path" : "/Text/Acknowledgments",
 			"name" : "Text/Acknowledgments",
 			"component" : TEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js